import { formatString } from '../utils/stringUtil';
import {
  OGP_IMAGE,
  OGP_IMAGE_TOP,
  OGP_SITE,
  OGP_TYPE,
  OGP_URLJOB_SEARCH_LIST,
  OGP_URL_JOB_SEARCH_DETAIL,
  OGP_URL_TOP,
} from '../constants/properties/arca';
import { QueryParams } from '../constants/queryParams';

export interface OgpValue {
  url: string;
  type: string;
  image: string;
  siteName: string;
}

export const getOgpForJobSearchDetail = (
  canonical: string | null,
  isScout: boolean,
  jid: string
): OgpValue | null => {
  if (isScout) return null;
  const url = canonical ?? formatString(OGP_URL_JOB_SEARCH_DETAIL, [jid]);
  const type = OGP_TYPE;
  const image = OGP_IMAGE;
  const siteName = OGP_SITE;

  return {
    url,
    type,
    image,
    siteName,
  };
};

export const getOgpForTop = (): OgpValue => {
  const url = OGP_URL_TOP;
  const type = OGP_TYPE;
  const image = OGP_IMAGE_TOP;
  const siteName = OGP_SITE;

  return {
    url,
    type,
    image,
    siteName,
  };
};
export const getOgpForJobSearchList = (
  canonical: string | null,
  query: QueryParams
): OgpValue => {
  let url = canonical;
  if (!url) {
    const param = createParam(query);
    url = formatString(OGP_URLJOB_SEARCH_LIST, [param]);
  }
  const type = OGP_TYPE;
  const image = OGP_IMAGE;
  const siteName = OGP_SITE;

  return {
    url,
    type,
    image,
    siteName,
  };
};

/**
 * TODO: spから移動する
 * クエリパラメーター生成
 * @param param クエリパラメーター生成用データ
 * @returns {string} クエリパラメーター
 */
export const createParam = (
  param: Record<string, string | number | boolean | null>
) => {
  return `?${Object.entries(param)
    .map((e) => (e[1] ? `${e[0]}=${e[1]}` : null))
    .filter((i) => i !== null)
    .join('&')}`;
};
